import { Heading, Text } from '@apollo/orbit';
import React from 'react';

import { Icon as IconPlanetWithFlagAndRings } from 'src/assets/icon-planet-with-flag-and-rings.svg';
import { Icon as IconPlanetWithStars } from 'src/assets/icon-planet-with-stars.svg';
import { useGrowthShowRoverCTA } from 'src/lib/featureFlags';

export const ReadOnlyLayout = () => {
  const shouldShowRoverInitComponent = useGrowthShowRoverCTA();
  return shouldShowRoverInitComponent ? (
    <div className="flex h-full flex-col justify-center gap-2 bg-primary p-8">
      <IconPlanetWithStars />
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-heading-xl">
          This organization hasn’t published any graphs yet
        </h1>
        <p className="pt-1 text-center">
          Graphs will appear on this page once they’re added by a team member
          with publishing access.
        </p>
      </div>
    </div>
  ) : (
    <div
      className="flex h-full flex-col justify-center gap-2 p-8 lg:px-[10%]"
      data-testid="empty-classic-graph-list-page"
    >
      <IconPlanetWithFlagAndRings className="mx-auto h-20 w-40" />

      <div className="flex flex-col items-center justify-center">
        <Heading variant="heading" size="2xl" className="mb-2">
          Welcome to GraphOS Studio
        </Heading>
        <Text className="text-center">
          Let’s get you moving in the right direction as you start your Apollo
          journey.
        </Text>
      </div>
    </div>
  );
};
